module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0051.png.bd91d816.jpg";